(($) => {
	
	let $window = $(window);


	$(document).ready( () => {
		
		applyInlinePopup();
		applyAjaxPopup();
		
		$('body').on( 'av_resize_finished', () => {
			setTimeout( () => {
				applyInlinePopup();
				applyAjaxPopup();
			}, 150);
		});
		
		$(".avia-highlight-col").addClass("pricing-table-hover");
		$(".pricing-table").on("hover", function(){
			$(".pricing-table.pricing-table-hover").removeClass("pricing-table-hover");
			$(this).addClass("pricing-table-hover");
		});
		
	});
	
	const applyInlinePopup = () => {
		
		$('a[href*="inline"], [data-popup]').on('click', function() {
			e.preventDefault();
			
			val = $(this).attr('href').split('?');
			
			$.magnificPopup.open({
				items: {
					src: '#'+val[0]
				},
				type: 'inline',
				showCloseBtn: true,
				mainClass: 'avia-popup mfp-zoom-in',
				tLoading: '',
				tClose: ''
			});
			
		});
	}
	
	const applyAjaxPopup = () => {
		$('a[href*="ajax=true"]').magnificPopup({
			type: 'ajax',
			showCloseBtn: true,
			mainClass: 'avia-popup mfp-zoom-in',
			tLoading: '',
			tClose: ''
		});
		
	}
	
})(jQuery);